

const EbayOAuth = () => "EbayOAuth";

export default EbayOAuth
